<form (ngSubmit)="updateDetails()" [formGroup]="form">
  <div class="form-group">
    <div class="anchor" id="video-sensitive-content-policy"></div>
    <!-- video-sensitive-content-policy anchor -->

    <div class="form-group">
      <my-select-radio
        [items]="nsfwItems"
        inputId="nsfwPolicy"
        isGroup="true"
        i18n-label
        label="Policy on videos containing sensitive content"
        formControlName="nsfwPolicy"
      ></my-select-radio>
    </div>

    @if (isNsfwFlagsEnabled()) {
      <div class="label" i18n>Override sensitive content policy for certain videos</div>

      <div class="form-group-description" i18n>
        These subjective criteria may be optionally applied to certain videos. The classification of some videos may differ from your personal judgment.
      </div>

      <div class="form-group mb-3">
        <my-select-radio
          [items]="nsfwFlagItems"
          inputId="nsfwFlagViolent"
          isGroup="true"
          labelSecondary="true"
          i18n-label
          label="Violent content"
          formControlName="nsfwFlagViolent"
        ></my-select-radio>
      </div>

      <div class="form-group mb-3">
        <my-select-radio
          [items]="nsfwFlagItems"
          inputId="nsfwFlagSex"
          isGroup="true"
          labelSecondary="true"
          i18n-label
          label="Sexually explicit material"
          formControlName="nsfwFlagSex"
        ></my-select-radio>
      </div>
    }
  </div>

  <div class="form-group">
    <div class="anchor" id="video-languages-subtitles"></div>
    <!-- video-languages-subtitles anchor -->

    <div class="pt-label-container">
      <label i18n for="videoLanguages">Only display videos in the following languages/subtitles</label>
      <my-help>
        <ng-container i18n>In Recently added, Trending, Local, Most liked and Search pages</ng-container>
      </my-help>
    </div>

    <div>
      <my-select-languages inputId="videoLanguages" [maxLanguages]="20" formControlName="videoLanguages"></my-select-languages>
    </div>
  </div>

  <ng-content select="inner-title"></ng-content>

  <div class="form-group">
    <my-peertube-checkbox inputName="p2pEnabled" formControlName="p2pEnabled" [recommended]="true" i18n-labelText labelText="Help share videos being played">
      <ng-container ngProjectAs="description">
        <span i18n
        >The <a class="link-primary" href="https://docs.joinpeertube.org/admin/privacy-guide#peertube-p2p-privacy" target="_blank">sharing system</a> implies
          that some technical information about your system (such as a public IP address) can be sent to other peers, but greatly helps to reduce server
          load.</span>
      </ng-container>
    </my-peertube-checkbox>
  </div>

  <div class="form-group">
    <my-peertube-checkbox inputName="autoPlayVideo" formControlName="autoPlayVideo" i18n-labelText labelText="Automatically play videos">
      <ng-container ngProjectAs="description">
        <span i18n>When on a video page, directly start playing the video.</span>
      </ng-container>
    </my-peertube-checkbox>
  </div>

  <div class="form-group">
    <my-peertube-checkbox
      inputName="autoPlayNextVideo"
      formControlName="autoPlayNextVideo"
      i18n-labelText
      labelText="Automatically start playing the next video"
    >
      <ng-container ngProjectAs="description">
        <span i18n>When a video ends, follow up with the next suggested video.</span>
      </ng-container>
    </my-peertube-checkbox>
  </div>

  <input *ngIf="!reactiveUpdate()" type="submit" i18n-value value="Save video settings" [disabled]="!form.valid" class="peertube-button primary-button mt-3">
</form>
